import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class TextareaDef {
  key?: string = uuid()
  type: 'textarea' = 'textarea'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: TextareaOptions = new TextareaOptions()
  rules?: Rule[]
}

export class TextareaOptions {
  defaultValue?: string
  disabled?: DisabledType = false
  labelWidth?: string | number
  placeholder?: string
  maxlength?: number
  required?: boolean = false
  rows?: number = 2
  autosize?: { minRows: number; maxRows: number } = { minRows: 2, maxRows: 6 }
  pattern?: string
}
